import { BusinessDetailsSection } from './BusinessDetailsSection'
import { RewardProgramSection } from './RewardProgramSection'
import type { components } from 'api/playerPayback/api'
import { States, useCurrentStateStore } from 'stores/useCurrentStateStore'

export const Overview = ({
  corporateAccount,
}: {
  corporateAccount: components['schemas']['FullCorporateAccountDTO']
}) => {
  const { currentStateName } = useCurrentStateStore()

  return (
    <>
      <BusinessDetailsSection corporateAccount={corporateAccount} />

      {currentStateName === States.ILLINOIS && (
        <RewardProgramSection corporateAccount={corporateAccount} />
      )}
    </>
  )
}
